import { EmbeddedRecordsMixin } from '@ember-data/serializer/rest';
import type Store from '@ember-data/store';
import type { ModelSchema } from '@ember-data/store/types';
import ApplicationSerializer from 'lumen/serializers/application';
import addIdsToSegmentationDataInApiResponse, {
  type RevenueInsightApiResponse,
} from 'lumen/utils/revenue-insight/model-utils';

// eslint-disable-next-line @typescript-eslint/no-unsafe-call
export default class ReviApiResponseSerializer extends ApplicationSerializer.extend(
  EmbeddedRecordsMixin,
) {
  attrs = {
    all: { embedded: 'always' },
    booking_lead_time: { embedded: 'always' },
    cancellation_lead_time: { embedded: 'always' },
    company: { embedded: 'always' },
    guest_country: { embedded: 'always' },
    impact_date: { embedded: 'always' },
    los: { embedded: 'always' },
    origin: { embedded: 'always' },
    pace: { embedded: 'always' },
    pickup: { embedded: 'always' },
    rate_code: { embedded: 'always' },
    room_type: { embedded: 'always' },
    segment: { embedded: 'always' },
    source: { embedded: 'always' },
    source_profile: { embedded: 'always' },
    travel_agent: { embedded: 'always' },
    weekday: { embedded: 'always' },
    subscription_id: { embedded: 'always' },
  };

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  normalizeResponse(
    store: Store,
    primaryModelClass: ModelSchema,
    payload: RevenueInsightApiResponse,
    id: string | number,
    requestType: string,
  ) {
    addIdsToSegmentationDataInApiResponse(payload);

    const allSegmentation = payload['all']?.[0];

    const restPayload = {
      'revi-api-responses': [
        {
          id: (allSegmentation?.['id'] as string).replace('all', 'data'),
          ...payload,
        },
      ],
    };

    // eslint-disable-next-line @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-return
    return super.normalizeResponse(
      store,
      primaryModelClass,
      restPayload,
      id,
      requestType,
    );
  }
}
